<script>
export default {
  name: "WebNotificationsChannelMixin",
  data() {
    return {
      serverMessage: ""
    };
  },
  channels: {
    WebNotificationsChannel: {
      received(message) {
        this.serverMessage = message;
      }
    }
  },
  mounted() {
    this.$cable.subscribe({
      channel: "WebNotificationsChannel",
      report_id: this.$router.currentRoute.params.id
    });
  },
  methods: {
    resetServerMessage() {
      this.serverMessage = "uploading";
    }
  }
};
</script>
